import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ahaApi from "../../../app/services/aha-api";
const initialState = {
  value: [],
  loading: false,
};

export const getRoutineManager = createAsyncThunk(
  "schedule/getRoutineManager",
  async (data, { rejectWithValue }) => {
    const response = await ahaApi.Account.routineReportingManager(data)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return rejectWithValue(err.response.data);
      });
    return response;
  }
);

export const getRoutineManagerSlice = createSlice({
  name: "getRoutineManager",
  initialState,
  reducers: {
    updateRoutineReportingDataVal(state, action) {
      state.value = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getRoutineManager.pending, (state) => {
        state.loading = true;
      })
      .addCase(getRoutineManager.fulfilled, (state, action) => {
        state.loading = false;
        state.value = action.payload;
      })
      .addCase(getRoutineManager.rejected, (state, err) => {
        state.loading = false;
        state.value = err.payload;
      });
  },
});

export const getRoutineManagerList = (state) => state.getRoutineManager.value;
export const { updateRoutineReportingDataVal } = getRoutineManagerSlice.actions;

export default getRoutineManagerSlice.reducer;
